<template>
  <div class="bg-gray-100 cursor-pointer flex flex-col justify-center sm:py-12" @click="click">
    <div v-if="showPage" class="relative sm:max-w-xl sm:mx-auto">
      <div class="relative px-4 bg-white shadow-lg sm:rounded-3xl">
        <div class="max-w-md mx-auto">
          <div>
            <br />
            <img :src="campaign.photo" />
          </div>
          <div class="divide-y divide-gray-200">
            <div class="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
              <h1 class="text-center md:font-bold">{{ campaign.label }}</h1>
              <v-md-preview :text="text" class="font-sans" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="relative sm:max-w-xl sm:mx-auto">
      <h1>
        <!--  -->
      </h1>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    campaign: Object,
    showPage: Boolean,
  },
  data() {
    return {
      text: this.campaign.description,
    }
  },
  methods: {
    click: function () {
      axios.get(`${window.location.href}&click=1`).then(() => window.open(this.campaign.url))
    },
  },
}
</script>

<style>
  .v-md-editor-preview.font-sans *
  {
	font-family: Cerebri Sans,
  ui-sans-serif,
  system-ui,
  -apple-system,
  BlinkMacSystemFont,
  "Segoe UI",
  Roboto,
  "Helvetica Neue",
  Arial,
  "Noto Sans",
  sans-serif,
  "Apple Color Emoji",
  "Segoe UI Emoji",
  "Segoe UI Symbol",
  "Noto Color Emoji";
  }
</style>
